import SpzLogo from "@/assets/logo-spz.svg";
import { Typography } from "@spz/ui/components/typography";
import { useTranslation } from "react-i18next";

export const ResourceNotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] mx-6 gap-6">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="w-[172px]" />
          </div>
          <div className="flex flex-col gap-2">
            <Typography variant="h3">{t("resource_not_found")}</Typography>

            <Typography className="text-gray-700">
              {t("resource_not_found_message")}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceNotFoundPage;
